import { render, staticRenderFns } from "./FullPageLayout.vue?vue&type=template&id=66bf1d0f&"
import script from "./FullPageLayout.vue?vue&type=script&lang=js&"
export * from "./FullPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports